import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Skeleton } from 'react-native-skeletons';
import { SkeletonText } from '@/components/skeleton-text';
import { useWindowDimensions, View } from 'react-native';

const SUBSCRIPTION_LOADING_SKELETON_HEIGHT = 120;

export const SubscriptionsLoader: React.FC = () => {
  const [styles] = useStyles();
  const dimensions = useWindowDimensions();
  const maxLoadingSkeletons = Math.ceil(
    dimensions.height / SUBSCRIPTION_LOADING_SKELETON_HEIGHT,
  );
  return (
    <View testID="subscriptions-loader">
      {[...new Array(maxLoadingSkeletons)].map((_, i) => (
        <View key={i} style={styles.loading}>
          <View style={styles.loadingTopRow}>
            <Skeleton
              borderRadius={8}
              height={48}
              style={styles.imageSkeleton}
              width={48}
            />
            <View style={styles.flex}>
              <SkeletonText width="50%" />
              <SkeletonText width="80%" />
            </View>
          </View>
          <SkeletonText width="100%" />
          <SkeletonText width="100%" />
        </View>
      ))}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  flex: {
    flex: 1,
  },
  imageSkeleton: {
    marginBottom: 8,
  },
  loading: {
    backgroundColor: theme.sk.color.bg.primary.default,
    borderRadius: 8,
    marginBottom: 8,
    marginHorizontal: 16,
    padding: 16,
  },
  loadingTopRow: {
    flexDirection: 'row',
    gap: 16,
  },
}));
